export const DEFAULT_MODE = "dark";
